import React, { Component } from 'react';
import Fade from './Fade.js';

import {CreateWidgetChooseSocialNetwork} from './CreateWidgetChooseSocialNetwork';
import {SenderVarsPage} from './SenderVarsPage';
import {SenderRedMessagePage} from './SenderRedMessagePage';
import axios from 'axios';
import Cookies from 'universal-cookie';
import MainHeaderUnderline from './MainHeaderUnderline';
import VkLogo from './vk_logo.png';
import TgLogo from './TgLogo.png';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { HorizontalLine } from './HorizontalLine.js';
import {InfoIcon} from './InfoIcon'
import { ThemeConsumer } from 'styled-components';


class MailingStats extends React.Component {

    state = {
        
        bot_name : '',
        text: '',
        photo: '',
        name: '',
        cnt_success: '',
        cnt_error: '',
        cnt_all: '',
        id: ''
    }
   
      
    constructor(props) {
        super(props);
        //console.log(this.props.data)
        
        
    }

    componentWillMount() {
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetMailingStats?mailing_id='+this.props.match.params.mailing_id,
        
        {
                    headers: {

                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                        
                         
                        console.log(res.data.info)
                        console.log(res.data.stats)
                        this.setState( {
                            
                            bot_name : res.data.info.bot_name,
                            channel_name : res.data.info.channel_name,
                            text: res.data.info.text,
                            photo: res.data.info.photo,
                            name: res.data.info.name,
                            cnt_success: res.data.stats.cnt_success,
                            cnt_error: res.data.stats.cnt_error,
                            cnt_all: res.data.stats.cnt_all,
                            id: res.data.info.id
                        });
                }, () => {
                    console.log(this.state)
                })
                .catch(err => {
                    console.log(err);
                    

                })
        
        
        
        

    }
  
    deleteMailing(e, mailing_id) {

        const cookies = new Cookies();
        axios.post(process.env.REACT_APP_BACKEND_SERVER + '/DeleteMailing/',
        {
            mailing_id : mailing_id
        }, {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    
                    if (res.data.status == 'ok') {
                        window.location = '/mailing'
                    }
                })
                .catch(err => {
                    console.log(err);
                    

                })


    }
    
    
    startSender(e, id) {

        const cookies = new Cookies()
        
        
        axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/StartSender/', {
                
                'mailing_id' : id
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                if (res.data.status == 'ok') {
                    window.location.href = '/mailingstats/'+id
                }
            })
            .catch(err => {
            console.log(err);
            })


    }
    
    
    
    
    render() {
        return (
            <div className='createPage'>
               <h1> Статистика по рассылке</h1>
                <MainHeaderUnderline />
                
                <div className='MailingStatsBlock'>
                    <div className='MailingStatsBlock_botName'>{ Boolean(this.state.bot_name) ? '@'+this.state.bot_name : <a style={{'color': '#0767F4', 'fontWeight': '600', 'fontFamily': 'Montserrat'}} target='_blank' href={'https://vk.com/'+this.state.channel_name}>{'https://vk.com/'+this.state.channel_name}</a> }</div>
                    <div className='MailingStatsBlock_senderName'>{this.state.name}</div>
                    
                    <div className='MailingStatsBlock_senderText'>
                {this.state.text}
                    </div>
                    {
                        this.state.photo ? <img  className='MailingStatsBlock_senderImage' src={this.state.photo}/> : null
                    }
                    
                    
                    <div className='MailingStatsBlock_statsBlock'>
                        <div className="MailingStatsBlock_statsBlock_blockName">Статистика </div>
                        <HorizontalLine classNameVar='mailingStatsUnderline' width='35' height='7'/>

                        <div className='MailingStatsBlock_statsBlock_infoBlock'>
                            {this.state.cnt_all == 0 ? <div ><InfoIcon /><span style={{marginLeft: '10px'}}>Рассылка не  запущена</span></div>  : null}
                        </div>
                        <div className="MailingStatsBlock_statsBlock_blockName_statBlock">
                            Cообщений ожидают отправки: 
                            
                            <span className="statBlockHighlightNumber">{this.state.cnt_all}</span></div>
                        <div className="MailingStatsBlock_statsBlock_blockName_statBlock">
                            Отправлено успешно: <span className="statBlockHighlightNumber">{this.state.cnt_success}</span></div>
                        <div className="MailingStatsBlock_statsBlock_blockName_statBlock">Отправлено с ошибкой: <span className="statBlockHighlightNumber">{this.state.cnt_error}</span></div>
                        
                        <div className='MailingStatsBlock_statsBlock_blockName_btnBlock'>
                        <a href='#' style={{background: '#FA5367'}} className="table_btn1 table_btn" onClick={(e) => {
                            this.deleteMailing(e, this.state.id)
                        }}>
                            Удалить 
                        </a>
                        {this.state.cnt_all > 0 ? null : <a href='#' className="table_btn1 table_btn" onClick={(e) => {
                            this.startSender(e, this.state.id)
                        }}> 
                            Запустить рассылку
                        </a>} 
                        
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>
                 
        )
    }
    
}

export default withRouter(MailingStats)